import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit lock-checkmark icon - from IcoMoonData/lock-checkmark.json
// Note: "lock-in-square" does not exist in cond-ui-kit; lock-checkmark (lock + checkmark) is used for Internal nav
const lockCheckmarkIconData = {
	icon: {
		attrs: [{}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M808 448h48c52.998 0 96 43 96 96v384c0 53-42.999 96-96 96h-704c-52.999 0-96-42.999-96-96v-384c0-52.998 42.999-96 96-96h48v-144c0-167.599 136.4-304 304-304s304 136.4 304 304v144zM360 304.001v144h288v-144c0-79.399-64.602-144-144-144s-144 64.602-144 144zM323.272 750.092l121.018 121.714c7.271 7.314 19.059 7.314 26.33 0.002l214.11-215.341c7.271-7.314 7.271-19.17 0-26.481l-26.33-26.481c-7.271-7.314-19.061-7.314-26.331 0l-174.614 175.618-81.523-81.992c-7.271-7.314-19.059-7.314-26.33 0l-26.33 26.481c-7.272 7.314-7.272 19.17 0 26.481z',
		],
		tags: ['lock - checkmark'],
		width: 1008,
	},
	attrs: [{}],
	properties: {
		code: 59736,
		id: 0,
		name: 'lock-checkmark',
		order: 3386,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 0,
};

// Create IconBuilder from cond-ui-kit data - same pattern as Integrations, Account
const LockInSquareIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	lockCheckmarkIconData as any,
	'#89c32e', // Default green color for new navigation (matches other secondary nav icons)
);

export default LockInSquareIconBuilder;
